import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AuctionsFormRequest} from '../../../shared/model/auctions-form-request.model';

@Injectable({
  providedIn: 'root'
})
export class AuctionsFormService {
  private readonly httpClient = inject(HttpClient);
  private readonly formRequestUrl = environment.backendAuctionsFormRequestUrl;

  sendContactMessage(contactMessage: AuctionsFormRequest) {
    return this.httpClient.post(this.formRequestUrl, contactMessage, {observe: 'response', responseType: 'text'});
  }
}
